import { Grid } from "@material-ui/core";
import { Help } from "@material-ui/icons";
import React, { useEffect } from "react";
import LoadingOverlay from 'react-loading-overlay';
import ReactLoading from 'react-loading';
import PaginatedTable from "utils/Table/PaginatedTable";
import ExportButton from "utils/CustomButtons/ExportToCVSButton";
import TooltipButton from "utils/TooltipButton/TooltipButton";
import { CallAPI } from "services/API";

const useMediaQuery = (query) => {
    const mediaMatch = window.matchMedia(query);
    const [matches, setMatches] = React.useState(mediaMatch.matches);

    useEffect(() => {
        const handler = e => setMatches(e.matches);
        mediaMatch.addEventListener("change", handler);
        return () => mediaMatch.removeEventListener("change", handler);
    });
    return matches;
};

export default function Projections(props) {
    const isMobile = useMediaQuery('(max-width: 1152px)');
    const currency = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
    const percent = new Intl.NumberFormat('en-US', {
        style: 'percent',
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
    });
    const headers = [["Month", "Projected", "Actual", "Variance"]];

    const [dataTotal, setDataTotal] = React.useState([]);
    const [loadingTotal, setLoadingTotal] = React.useState(false);
    const [dataNewBusiness, setDataNewBusiness] = React.useState([]);
    const [loadingNewBusiness, setLoadingNewBusiness] = React.useState(false);
    const [dataRenewals, setDataRenewals] = React.useState([]);
    const [loadingRenewals, setLoadingRenewals] = React.useState(false);

    const GetData = async (type) => {
        const response = await CallAPI("POST", `/Projections/Get${type}`, {
            states: props.states
        });

        if (response) {
            const formattedResponse = response.map((row) => {
                if (row.month.includes("MTD")) {
                    return {
                        style: { fontWeight: "800" },
                        cells: [
                            (<>{row.month}<TooltipButton tooltipText={" MTD based on number of days passed within current month"} style={{ maxHeight: "20px", position: "absolute" }} icon={<Help style={{ width: ".75em" }} />} /></>),
                            currency.format(row.projected),
                            currency.format(row.actual),
                            percent.format(Math.round(row.variance) == -0 ? 0 : Math.round(row.variance) / 100),
                        ]
                    };
                } else if (row.month.includes("YTD")) {
                    return {
                        style: { fontWeight: "800" },
                        cells: [
                            row.month,
                            currency.format(row.projected),
                            currency.format(row.actual),
                            percent.format(Math.round(row.variance) == -0 ? 0 : Math.round(row.variance) / 100),
                        ]
                    };
                } else if (row.month.includes("TOTAL")) {
                    return {
                        style: { fontWeight: "800", backgroundColor: "lightgrey" },
                        cells: [
                            (<>{row.month}<TooltipButton tooltipText={" Full year projected total"} style={{ maxHeight: "20px", position: "absolute" }} icon={<Help style={{ width: ".75em" }} />} /></>),
                            currency.format(row.projected),
                            currency.format(row.actual),
                            percent.format(Math.round(row.variance) == -0 ? 0 : Math.round(row.variance) / 100),
                        ]
                    };
                } else {
                    return [
                        row.month,
                        currency.format(row.projected),
                        currency.format(row.actual),
                        percent.format(Math.round(row.variance) == -0 ? 0 : Math.round(row.variance) / 100),
                    ];
                }
            });

            switch (type) {
                case "Total":
                    setDataTotal(formattedResponse); break;
                case "NewBusiness":
                    setDataNewBusiness(formattedResponse); break;
                case "Renewals":
                    setDataRenewals(formattedResponse); break;
            }
        }

        switch (type) {
            case "Total":
                setLoadingTotal(false); break;
            case "NewBusiness":
                setLoadingNewBusiness(false); break;
            case "Renewals":
                setLoadingRenewals(false); break;
        }
    };

    useEffect(() => {
        GetData("Total");
        setLoadingTotal(true);
        GetData("NewBusiness");
        setLoadingNewBusiness(true);
        GetData("Renewals");
        setLoadingRenewals(true);
    }, []);

    return (
        <Grid item
            style={
                isMobile ?
                    {
                        margin: "0em",
                        padding: "1em",
                        paddingRight: "1em",
                        width: "100%",
                        paddingTop: "1em",
                        backgroundColor: "#f1f1f1",
                        fontSize: "1.3em",
                        position: "relative",
                        textAlign: "center"
                    }
                    :
                    {
                        backgroundColor: "#f1f1f1",
                        width: "100%",
                        margin: "1em",
                        padding: "1em",
                        fontSize: "2.5em",
                        position: "relative",
                        textAlign: "center"
                    }
            }
        >
            <span
                style={{ fontSize: ".7em", marginTop: "1em" }}
            >
                <span
                    style={{
                        fontWeight: "bold",
                        color: "#1d4c80"
                    }}
                >
                    TOTAL - {props.title}
                </span>
            </span>
            <LoadingOverlay
                active={loadingTotal}
                styles={{ overlay: (base) => ({ ...base, position: "absolute!important" }) }}
                spinner={<ReactLoading type={'spin'} height={50} width={50} />}
            >
                <PaginatedTable
                    style={{ Header: { textAlign: "left" }, Body: { textAlign: "left" }, Footer: { textAlign: "left" } }}
                    headers={headers}
                    fixedColumns={1}
                    rows={dataTotal}
                />
            </LoadingOverlay>
            <ExportButton
                ExportName={`Total_${props.states.join("_")}`}
            />
            <br />
            <br />
            <span
                style={{ fontSize: ".7em", marginTop: "1em" }}
            >
                <span
                    style={{
                        fontWeight: "bold",
                        color: "#1d4c80"
                    }}
                >
                    NEW BUSINESS - {props.title}
                </span>
            </span>
            <LoadingOverlay
                active={loadingNewBusiness}
                styles={{ overlay: (base) => ({ ...base, position: "absolute!important" }) }}
                spinner={<ReactLoading type={'spin'} height={50} width={50} />}
            >
                <PaginatedTable
                    style={{ Header: { textAlign: "left" }, Body: { textAlign: "left" }, Footer: { textAlign: "left" } }}
                    headers={headers}
                    fixedColumns={1}
                    rows={dataNewBusiness}
                />
            </LoadingOverlay>
            <ExportButton
                ExportName={`NewBusiness_${props.states.join("_")}`}
            />
            <br />
            <br />
            <span
                style={{ fontSize: ".7em", marginTop: "1em" }}
            >
                <span
                    style={{
                        fontWeight: "bold",
                        color: "#1d4c80"
                    }}
                >
                    RENEWALS - {props.title}
                </span>
            </span>
            <LoadingOverlay
                active={loadingRenewals}
                styles={{ overlay: (base) => ({ ...base, position: "absolute!important" }) }}
                spinner={<ReactLoading type={'spin'} height={50} width={50} />}
            >
                <PaginatedTable
                    style={{ Header: { textAlign: "left" }, Body: { textAlign: "left" }, Footer: { textAlign: "left" } }}
                    headers={headers}
                    fixedColumns={1}
                    rows={dataRenewals}
                />
            </LoadingOverlay>
            <ExportButton
                ExportName={`Renewals_${props.states.join("_")}`}
            />
        </Grid>
    );
}
